import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchStaffMembers,
  SearchStaffMembersVariables
} from "./types/SearchStaffMembers";

export const searchStaffMembers = gql`
  ${pageInfoFragment}
  query SearchStaffMembers(
    $after: String
    $first: Int!
    $query: String!
    $smopUserType: [SmopUserTypeCode]
  ) {
    search: staffUsers(
      after: $after
      first: $first
      filter: { search: $query, smopUserType: $smopUserType }
    ) {
      edges {
        node {
          id
          email
          firstName
          lastName
          isActive
          avatar {
            alt
            url
          }
          contactNo
          dateJoined
          status
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchStaffMembers,
  SearchStaffMembersVariables
>(searchStaffMembers);
